import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import HavenSelection from "../Selection2/HavenSelection";
import DualEleganceSelection from "../Selection2/DualEleganceSelection";
import LightAndSpaceSelection from "../Selection2/LightAndSpaceSelection";
import LightAndSpaceShow from "../InteriorDesignComponents/InteriorShow/LightAndSpaceShow";
import ReactPlayer from "react-player";

export default function LightAndSpaceComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/lightandspace/Living%20Room/R3.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">Light and Space</p>

              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                role in project: architectural drawings, 3d visualization

                </span>
                <span>project duration: 5 months</span>
                <span>year of completion: 2024</span>
                <span>project location:Yenimahalle, Ankara-TURKIYE</span>
              </div> */}
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/lightandspace/Living%20Room/1.a.deneme.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                src="../../Images/ResidentialImages/lightandspace/Living%20Room/R2.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Transformative
                <br />
                lighting
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                design
                <br />
                shaping
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                space
                <br />
                experiences
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              “Exploring the transformative power of light and design, where
              spaces evolve to reveal their full potential”
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="../../Images/ResidentialImages/lightandspace/Living%20Room/R2.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              This conceptual project is a strong example of the transformative
              effect of lighting and illustrative techniques in interior spaces.
              By contrasting the plain, minimalist 'before' visuals of the
              living room with the more detailed and layered 'after' imagery,
              the project highlights how thoughtful design choices can change
              how a space is experienced.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/ResidentialImages/lightandspace/Living%20Room/154c9ead72ae607dafedf0be4e4469a3.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <LightAndSpaceSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/lightandspace/Living%20Room/R3b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                  textTransform: "capitalize",
                }}
              >
                "Illuminating Transformations”
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>

        <section className="video-player">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactPlayer
              url="../../Images/ResidentialImages/lightandspace/Living%20Room/BLR.mp4" // Replace with your video URL
              controls
              width="80%"
              height="100vh"
            />
          </div>
        </section>

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "35px",
                  textTransform: "uppercase",
                  padding: "50px",
                  paddingBottom:"50px"
                }}
              >
                The bedroom visuals expand on this idea, showing the combination
                of ambient, task, and accent lighting, paired with selected
                textures and colors. These contrasts show the impact of
                intentional lighting design and material choices in creating
                different atmospheres, emphasizing how spatial dynamics and
                emotions can be deeply influenced by these elements. This
                project goes beyond appearance, exploring how light and design
                bring life to a space.
              </h1>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
<div
style={{
  marginTop:"70px"
}}
  >
<LightAndSpaceShow />
</div>
     
        <InteriorDesignResidentialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
